import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Terms() {
  return (
    <section data-testid="terms-page" className="pt-32 pb-28 lg:pt-40">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal y={14}>
          <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-bark">
            <span className="h-px w-10 bg-bark" aria-hidden="true" />
            Terms &amp; Conditions
          </p>
        </Reveal>
        <h1 className="mt-6 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          The fine print, <em className="font-editorial italic text-bark">in plain words.</em>
        </h1>
        <Reveal delay={0.3}>
          <div
            data-testid="terms-placeholder"
            className="mt-12 rounded-3xl border border-dashed border-ink/15 bg-white/60 p-8 sm:p-12"
          >
            <p className="text-base leading-relaxed text-slate-600 sm:text-lg">
              Our full Terms &amp; Conditions are being drafted with care — covering boarding stays,
              day care, grooming, training, events, vaccinations and health requirements.
            </p>
            <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
              They will be published right here shortly. Until then, our team is happy to walk you
              through how we care for your pup — just reach out on any of our social channels.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-12">
            <Link
              to="/"
              data-testid="terms-back-home"
              className="group inline-flex items-center gap-2 text-sm font-semibold text-navy"
            >
              <ArrowLeft
                className="h-4 w-4 text-bark transition-transform duration-200 group-hover:-translate-x-1"
                aria-hidden="true"
              />
              Back to home
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
